import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { AppInstallPermission, isCompatibleMarketplaceProduct, StargateAPI } from '@atlassian/mpac-services-client';
import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/graphql-gateway-types';
import { foldPermissionIdentifier, instanceToModule, returnsPromise, unsupported } from './connect/Util';
import { getRawCloudMarketplaceAppByKey } from './GraphQLGatewayApi';
import { makeAppKey } from './types/UPM.types';
import { getInstallPermissions } from './upmApi';
const formatInstallPermissionToSPI = canInstallApp => canInstallApp ? {
  allowed: true
} : {
  allowed: false,
  message: 'No addon manage permission',
  key: 'noAddonManagePermission'
};
const checkInstallPermissionFromStargate = (config, marketplaceApp, installPermission) => {
  const product = config.product;
  if (isCompatibleMarketplaceProduct(product)) {
    var _marketplaceApp$versi;
    const paymentModel = (_marketplaceApp$versi = marketplaceApp.version) === null || _marketplaceApp$versi === void 0 ? void 0 : _marketplaceApp$versi.paymentModel;
    return paymentModel === MarketplaceAppPaymentModel.Free ? installPermission !== AppInstallPermission.CANNOT_INSTALL : installPermission === AppInstallPermission.CAN_INSTALL_FREE_AND_PAID;
  }
  return false;
};
let Permissions = (_class = class Permissions {
  constructor(config) {
    _defineProperty(this, "config", void 0);
    this.config = config;
  }
  async hasInstallPermission(options) {
    return foldPermissionIdentifier(options.addon)(async keyIdentifier => {
      const response = await getInstallPermissions(this.config.baseUrl, keyIdentifier.details.key);
      return formatInstallPermissionToSPI(response);
    }, async ariIdentifier => {
      const {
        gqlGatewayUrl
      } = this.config;
      const product = this.config.product;
      if (isCompatibleMarketplaceProduct(product)) {
        const starGateUrl = this.config.environment === 'local' ? "".concat(this.config.baseUrl, "/gateway/api") : '/gateway/api';
        const [marketplaceApp, installPermission] = await Promise.all([getRawCloudMarketplaceAppByKey(makeAppKey(ariIdentifier.details.key), gqlGatewayUrl), new StargateAPI(starGateUrl).marketplace.appInstallPermission(product, this.config.cloudId)]);
        const permission = checkInstallPermissionFromStargate(this.config, marketplaceApp, installPermission);
        return formatInstallPermissionToSPI(permission);
      } else {
        return formatInstallPermissionToSPI(false);
      }
    });
  }
  hasUninstallPermission(_options) {
    return Promise.reject();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "hasInstallPermission", [returnsPromise], Object.getOwnPropertyDescriptor(_class.prototype, "hasInstallPermission"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUninstallPermission", [returnsPromise, unsupported], Object.getOwnPropertyDescriptor(_class.prototype, "hasUninstallPermission"), _class.prototype)), _class);
export default (config => instanceToModule(new Permissions(config)));